import React, {Component} from 'react';
import send from '../utils/ChatServer.js';
import PieChart from 'react-minimal-pie-chart';
import {NotificationManager} from 'react-notifications';
import moment from 'moment';
import {Link} from 'react-router-dom';

class Tasks extends Component {
    componentWillUnmount(){
        let {currentLog} = this.props;
        currentLog.end = new Date();
        this.props.updateLog(currentLog, this.props.user.id);
    }
    componentDidMount(){
        if(this.props.match.params.courseId){
            this.props.onLoad(this.props.user.user.Profile.id, this.props.match.params.courseId, this.props.user.id);
        }else{
            this.props.onLoad(this.props.user.user.Profile.id, null, this.props.user.id);
        }

        let newLog = {
            date: new Date(),
            duration: 0,
            type: 'Tasks',
            subject: '',
            chapter: '',
            activity: '',
            score: 'NA',
            courseUserId: this.props.courseUser[0].id,
            userId: this.props.user.user.id
        }

        this.props.createLog(newLog, this.props.user.id);
    }
    
    completeTask = (taskId) => {
        let task = this.props.tasks.filter(task => task.id === taskId);
        if(task.length > 0){
            task = task[0];
            task.progress = 100;
            let command = {
                type: 'UPDATE_TASK',
                task: task,
                profileId: this.props.courseUser[0].profileId
            };
            
            send(command, this.props.socket, this.props.user.id);
    
            
            NotificationManager.success("Task complete!  Great job!");
        }
    }
    
    renderCount = (type) => {
        let tasks = [];
        if(type === 'complete'){
            tasks = this.props.tasks.filter(t => t.progress === 100);
        }else if(type === 'active'){
            tasks = this.props.tasks.filter(t => t.progress < 100 && moment().diff(moment(moment(t.date).format('MM/DD/YYYY')), 'days') === 0);
        }else if(type === 'assigned'){
            tasks = this.props.tasks.filter(t => t.assigned && moment().diff(moment(moment(t.date).format('MM/DD/YYYY')), 'days') === 0);
        }else {
            tasks = this.props.tasks;
        }
        
        if(tasks.length > 0){
            return (
                <span className="btn-counter">{tasks.length}</span>    
            )
        }else{
            return null;
        }
    }
    
    renderNamePage = () => (
        <div className="bg-light lter b-b wrapper-md">
            <div className="row">
                <div className="col-sm-6 col-xs-6">
                    <h1 className="m-n font-thin h3 text-black">
                        Tasks
                    </h1>
                    <small className="text-muted">
                        
                    </small>
                </div>
                <div className="ml-auto col-sm-6 col-xs-6 text-right">
                    <Link to={`/tasks`} className={`btn btn-${(!this.props.match.params.courseId) ? 'primary' : 'default'}`}>All {this.renderCount('')}</Link> &nbsp;
                    <Link to={`/tasks/active`} className={`btn btn-${(this.props.match.params.courseId === 'active') ? 'primary' : 'default'}`}>Active {this.renderCount('active')}</Link> &nbsp;
                    <Link to={`/tasks/assigned`} className={`btn btn-${(this.props.match.params.courseId === 'assigned') ? 'primary' : 'default'}`}>Assigned {this.renderCount('assigned')}</Link> &nbsp;
                    <Link to={`/tasks/complete`} className={`btn btn-${(this.props.match.params.courseId === 'complete') ? 'primary' : 'default'}`}>Complete {this.renderCount('complete')}</Link> &nbsp;
                </div>
            </div>
        </div>
    );
    
    renderTaskCards = (tasks, disableIncomplete, showDate) => {
        
        if(this.props.match.params.courseId === 'complete'){
            tasks = tasks.filter(t => t.progress === 100);
        }else if(this.props.match.params.courseId === 'active'){
            tasks = tasks.filter(t => t.progress < 100);
        }else if(this.props.match.params.courseId === 'assigned'){
            tasks = tasks.filter(t => t.assigned);
        }
        
        return tasks.sort((a, b) => a.date < b.date || b.date > a.date).map((t, i) => {
            let course = this.props.courseUser.filter(cu => cu.id === t.courseUserId);
            if(course.length > 0){
                course = course[0].Course;
                return (
                    <div className="task-card-container" key={i}>
                    <div className={`task-card-small ${disableIncomplete ? 'disabled' : ''} ${t.progress > 0 ? 'activeTask' : ''}`} data-toggle="collapse" data-target={`#SubTasks-${t.id}`} aria-expanded="false" aria-controls={`SubTasks-${t.id}`} onClick={e => {
                        if(typeof(t.value) === 'object'){
                            if(t.value.length === 1){
                                if(t.value[0].test){
                                    this.props.history.push('/subject-test/' + t.value[0].value);
                                }else{
                                    this.props.history.push('/video/item/' + t.value[0].value);
                                }
                            }
                        }else{
                            if(t.test){
                                    this.props.history.push('/subject-test/' + t.value);
                                }else{
                                    this.props.history.push('/video/item/' + t.value);
                                }
                        }
                    }}>
                        <div className="row">
                            <div className="col-sm-1">
                                <div className="pull-left task-progress">
                                    {t.progress === 100 ?
                                        <div className="task-icon text-success">
                                            <i className="zmdi zmdi-check" />
                                        </div>
                                    :
                                        disableIncomplete ?
                                            <div className="task-icon text-danger">
                                                <i className="zmdi zmdi-close" />
                                            </div>
                                        :
                                        <span>
                                            <PieChart
                                                style={{width: 48, margin: '0 auto'}}
                                                data={[
                                                    {value: 100, color: '#222'},
                                                    {value: t.progress, color: '#e33339'}
                                                ]}
                                                totalValue={100}
                                                startAngle={-90}
                                                lineWidth={10}
                                                rounded={true}
                                            />
                                            <p className="diagnostic-pie-chart-counter">{t.progress}%</p>
                                        </span>
                                    }
                                </div>
                            </div>
                        
                        
                        <div className="col-md-6 task-title">
                            <div className="">
                                {t.title}
                                {typeof(t.value) === 'object'?
                                    t.value.length > 1 &&
                                        <span> ({t.value.length})</span>
                                    : null}
                            </div>
                        </div>
                        <div className="col-md-5 text-right">
                            <div className="task-actions pull-right">
                            
                                {showDate ?
                                    <span className="task-time">{moment(t.date).format('MMM DD YYYY')}</span>
                                : null}
                                {t.progress < 100 && t.value.length === 0 &&
                                    <button className="btn btn-transparent" onClick={e => this.completeTask(t.id)}><i className="zmdi zmdi-check" /></button>
                                }
                                
                                
                                
                                {typeof(t.value) === 'object'?
                                    t.value.length > 1 &&
                                        <button className="btn btn-transparent"><i className="zmdi zmdi-more-vert" /></button>
                                    : null}
                                
                            </div>
                            {t.subjectName &&
                            <div className="task-course task-title">
                                {t.subjectName} - {t.chapterName}
                                
                            </div>
                            }
                            
                           
                            
                        </div>
                        </div>
                        </div>
                        
                        {typeof(t.value) === 'object'?
                            t.value.length > 1 &&
                            <div className="card-expanded collapse" id={`SubTasks-${t.id}`}>
                                {this.renderTaskCards(t.value)}
                            </div>
                            : null
                        }
                    
                    </div>
                )
            }
        })
        
        
    }
    
    applyFilters = (tasks) => {
        if(this.props.match.params.courseId === 'complete'){
            return tasks = tasks.filter(t => t.progress === 100);
        }else if(this.props.match.params.courseId === 'active'){
            return tasks = tasks.filter(t => t.progress < 100);
        }else if(this.props.match.params.courseId === 'assigned'){
            return tasks = tasks.filter(t => t.assigned);
        }else{
            return tasks;
        }
    }
    
    renderTasks = () => {
        let {tasks} = this.props;
        tasks = tasks.sort((a, b) => a.number > b.number || b.number < a.number);
        let todaysTasks = tasks.filter(t => moment().diff(moment(moment(t.date).format('MM/DD/YYYY')), 'days') === 0 && t.progress !== 100);
        let completedToday = tasks.filter(t => moment().diff(moment(moment(t.date).format('MM/DD/YYYY')), 'days') === 0 && t.progress === 100);
        let yesterdaysTasks = tasks.filter(t => moment().diff(moment(moment(t.date).format('MM/DD/YYYY')), 'days') === 1  && t.progress === 100);
        let notCompleteYesterday = tasks.filter(t => moment().diff(moment(moment(t.date).format('MM/DD/YYYY')), 'days') === 1  && t.progress !== 100);
        let olderTasks = tasks.filter(t => moment().diff(moment(moment(t.date).format('MM/DD/YYYY')), 'days') > 1);
        
        return (
            <div className="task-group-container">
                {this.applyFilters(todaysTasks).length > 0 || this.applyFilters(completedToday).length > 0 ?
                    <div className="group-section">
                        <h3 className="task-section-title">Today</h3>
                        <div className="task-items">
                            {this.applyFilters(todaysTasks).length === 0 && this.applyFilters(completedToday).length === 0 ?
                                <div className="no-comments">No tasks to show</div>
                            :
                            <div>
                                {this.renderTaskCards(todaysTasks, false, false)}
                                {this.renderTaskCards(completedToday, false, false)}
                             </div>
                            }
                        </div>
                    </div>  
                    : null
                }
                
                {this.applyFilters(yesterdaysTasks).length > 0 || this.applyFilters(notCompleteYesterday).length > 0 ?
                    <div className="group-section">
                        <h3 className="task-section-title">Yesterday</h3>
                        <div className="task-items">
                            {this.renderTaskCards(notCompleteYesterday, true, false)}
                            {this.renderTaskCards(yesterdaysTasks, false, false)}
                        </div>
                    </div>  
                    : null
                }
                
                {this.applyFilters(olderTasks).length > 0 ?
                    <div className="group-section">
                        <h3 className="task-section-title">Older</h3>
                        <div className="task-items">
                            {this.renderTaskCards(olderTasks, true, true)}
                        </div>
                    </div>  
                    : null
                }
            </div>
            
        )
        
    }
    
    renderTasksOld = () => {
        let tasks = this.props.tasks;

        if(this.props.match.params.courseId === 'complete'){
            tasks = tasks.filter(t => t.progress === 100);
        }else if(this.props.match.params.courseId === 'active'){
            tasks = tasks.filter(t => t.progress < 100);
        }
        return tasks.map(task => {
            let course = this.props.courseUser.filter(cu => cu.id === task.courseUserId)[0].Course;
            if(course){
                return (
                    <div className="col-md-3">
                        <div className="task-card">
                            {task.value.length > 0 &&
                            <span>
                            <PieChart
                                style={{width: 100, margin: '0 auto'}}
                                data={[
                                    {value: 100, color: '#2a2a2a'},
                                    {value: task.progress, color: '#e33339'}
                                ]}
                                totalValue={100}
                                startAngle={-90}
                                lineWidth={10}
                                rounded={true}
                            />
                            <p className="diagnostic-pie-chart-counter">{task.progress}%</p>
                            </span>
                            }
                                                        
                        <h3>{task.title}</h3>
                        <h5>{course.name}</h5>
                        {task.value.length > 0 ?
                        <ul className="task-list">
                            {task.value.map((t, i) => {
                            if(task.currentIndex > i){
                                return (
                                    <li><i className="zmdi zmdi-check" /> {t.label}</li>
                                )
                            }else{
                                return (
                                    <li><i className="zmdi zmdi-square-o" /> 
                                    
                                    {task.currentIndex === i ?
                                        <Link to={`${t.test === true ? '/subject-test/' + t.value : '/video/item/' + t.value}`}>{t.label}</Link>
                                    :
                                    t.label
                                        
                                    }</li>
                                )
                            }
                                
                            })
                            
                            }
                        </ul>
                        :
                            <div className="text-center">
                                {task.progress < 100 &&
                                    <button className="btn btn-success" onClick={e => this.completeTask(task.id)}>Mark Complete</button>
                                }
                            </div>
                        }
                        </div>
                    </div>
                )
            }else{
                return null
            }
        })
    }
    
    
    
    render(){
        return (
            <div className="content-wrapper" id="content-container">
                {this.renderNamePage()}

                <section className="content">
                    <div className="row">
                        {this.renderTasks()}
                    </div>
                </section>
            </div>
        )
    }
}

export default Tasks;


// WEBPACK FOOTER //
// ./src/components/Tasks.js